/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 活動区分
 */
export type IncidentActivityTypeEnum =
  (typeof IncidentActivityTypeEnum)[keyof typeof IncidentActivityTypeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IncidentActivityTypeEnum = {
  PATIENT_TRANSPORT: 'PATIENT_TRANSPORT',
  DOCTOR_TRANSPORT: 'DOCTOR_TRANSPORT',
  EQUIPMENT_TRANSPORT: 'EQUIPMENT_TRANSPORT',
  NON_EMERGENCY: 'NON_EMERGENCY',
  NO_PATIENT: 'NO_PATIENT',
  REFUSAL: 'REFUSAL',
  INTOXICATION: 'INTOXICATION',
  OBVIOUS_DEATH: 'OBVIOUS_DEATH',
  ON_SITE_TREATMENT: 'ON_SITE_TREATMENT',
  FALSE_ALARM: 'FALSE_ALARM',
  DECLINED_BEFORE_ARRIVAL: 'DECLINED_BEFORE_ARRIVAL',
  DECLINED_AFTER_ARRIVAL: 'DECLINED_AFTER_ARRIVAL',
  TRANSPORTED_BY_OTHER_UNIT: 'TRANSPORTED_BY_OTHER_UNIT',
  OTHER: 'OTHER',
} as const;
